var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "item mb-2",
      class: { current: _vm.isCurrent },
      on: { click: _vm.onClick },
    },
    [
      _c(
        "div",
        { staticClass: "item-title d-flex justify-content-end" },
        [
          _vm.hasStatusSent
            ? _c("span", { staticClass: "badge badge-purple" }, [
                _vm._v(_vm._s(_vm.formattedSentAt)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasStatusError
            ? _c(
                "el-popover",
                {
                  attrs: {
                    placement: "left-start",
                    trigger: "hover",
                    width: "300",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "text-break" }, [
                              _c("div", { staticClass: "text-pre-wrap" }, [
                                _c("strong", [_vm._v("Code:")]),
                                _vm._v(" " + _vm._s(_vm.errorCode)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "w-100" }, [
                                _c("strong", [_vm._v("Description:")]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.errorDescription)),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3429447426
                  ),
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "badge badge-danger",
                      attrs: { slot: "reference" },
                      slot: "reference",
                    },
                    [_vm._v("ERROR")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasStatusQueued
            ? _c("span", { staticClass: "badge badge-warning" }, [
                _vm._v("QUEUED"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "contact",
        domProps: { textContent: _vm._s(_vm.contactLine) },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "outgoing-number",
        domProps: { textContent: _vm._s(_vm.outgoingNumberLine) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }